// frontend/src/services/auth.js
import API_URL from '../config/api';

const login = async (email, password) => {
   console.log('Enviando login:', { email, password });
  const response = await fetch(`${API_URL}/auth.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();
  console.log('Resposta do backend:', data);
  if (!response.ok || !data.success) throw new Error(data.error || 'Erro ao fazer login');
  localStorage.setItem('user', JSON.stringify(data.user));
  localStorage.setItem('token', data.token);
  return data;
};

const logout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
};

const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  return null;
};

const getToken = () => {
  return localStorage.getItem('token');
};

// --- ATUALIZADO: Adiciona o parâmetro 'role' ---
const createUser = async (nome, email, password, role = 'lider') => {
  const token = getToken();
  if (!token) throw new Error('Você não está autenticado.');

  const response = await fetch(`${API_URL}/users.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    // ADICIONADO: Envia o 'role' no corpo da requisição
    body: JSON.stringify({ nome, email, password, role }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Erro ao criar usuário');
  }

  return data;
};

const getUsers = async () => {
    const token = getToken();
    if (!token) throw new Error('Você não está autenticado.');

    const response = await fetch(`${API_URL}/users.php`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    });

    if (!response.ok) throw new Error('Erro ao buscar usuários');
    return response.json();
};

export default {
  login,
  logout,
  getCurrentUser,
  getToken,
  createUser,
  getUsers,
};